import React from 'react';
import PropTypes from 'prop-types';

function direction(locale) {
  return locale && locale.substr(0, 2) === 'ar' ? 'rtl' : 'ltr';
}

function lang(locale) {
  return locale && locale.substr(0, 2);
}

const LanguageDirection = props => (
  <div lang={lang(props.locale)} dir={direction(props.locale)}>
    {props.children}
  </div>
);

LanguageDirection.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.array,
};

LanguageDirection.defaultProps = {
  locale: '',
  children: [],
};

export default LanguageDirection;
